<template>
    <div class="ChildRecord" v-if="ChildRecordData.SubProgram">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-md-2">
                    <div><img class="photo-border-square" v-bind:src="ProfilePhotoFileID" style="width:100%;border-radius:20px;" />
                    </div>
                </div>
                <div class="col col-md-10">
                    <button type="button" class="close" v-on:click="CloseRecord"><span>x</span></button>
                    <h1><span>{{ ChildRecordData.Client.Person.FirstName }}</span> <span v-if="ChildRecordData.Client.Person.AKA">"{{ ChildRecordData.Client.Person.AKA }}"</span> <span>{{ ChildRecordData.Client.Person.LastName }}</span></h1>
                    <h4><span>DOB: </span><span>{{ formatDate(ChildRecordData.Client.Person.DOB, 'MM/DD/YY') }}</span><span> Age: </span><span>{{ ChildRecordData.Client.Person.AgeString }}</span></h4>
                    <h4><span>{{ ChildRecordData.SubProgram.Name }}: </span><span>{{ formatDate(ChildRecordData.StartDate, 'MM/DD/YY') }}</span><span> - </span><span>{{ formatDate(ChildRecordData.EndDate, 'MM/DD/YY', 'Present') }}</span></h4>
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col">
                    <div class="record-tabs">
                        <span class="d-none d-sm-block">
                            <b-nav>
                                <div v-for="pane in Panes">
                                    <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                </div>
                            </b-nav>
                        </span>
                        <b-nav>
                            <span class="d-sm-none">
                                <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                    <div v-for="pane in Panes">
                                        <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                    </div>
                                </b-nav-item-dropdown>
                            </span>
                        </b-nav>
                    </div>
                    <div class="tab-content">
                        <div v-show="PaneShown == 'Summary'">
                            <ChildSummary v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Client Info'">
                            <Information v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Program'">
                            <Program v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'People'">
                            <People v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Housing Assignments'">
                            <HousingAssignmentsPane :child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Case File'">
                            <CaseFile chart-type="ClientSubProgramMembership"
                                      :chart-record-id="ChildRecordData.Id"
                                      :sub-program-id="ChildRecordData.SubProgramID" />
                        </div>
                        <div v-show="PaneShown == 'New Document'">
                            <NewDocument :form-memberships="SubProgramFormMemberships"
                                         :chart-record-id="ChildRecordData.Id" chart-type="ClientSubProgramMembership" />
                        </div>
                        <div v-show="PaneShown == 'Youth Log'">
                            <ClientServiceLog v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Admin'">
                            <Admin v-bind:child-record-data="ChildRecordData" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import Admin from "./Admin.vue";
    //import Audit from "./Audit.vue";
    import Information from "./Information.vue";
    import Program from "./Program.vue";
    import People from "./People.vue";
    import ChildSummary from "./Summary.vue";
    import CaseFile from "../../../Core/RecordComponents/CaseFile.vue";
    import NewDocument from "../../../Core/RecordComponents/NewDocument.vue";
    import ClientServiceLog from './ClientServiceLog.vue';
    import HousingAssignmentsPane from "./HousingAssignmentsPane.vue";
    import { EventBus } from '../../../../services/event-bus.js';
    export default {
        props: [
            'ChildRecordData'
        ],
        created() {
            let vm = this;
            EventBus.$on('profile-update-needed', chartID => {
                if (chartID == vm.ChildRecordData.Id) {
                    vm.UpdateChartData();
                    vm.ProfilePhotoURL();
                }
            });
            EventBus.$on('global-update-initiated', this.UpdateChartData);
        },
        beforeDestroy() {
            EventBus.$off('profile-update-needed');
            EventBus.$off('global-update-initiated');
        },
        data: function () {
            return {
                PaneShown: "Summary",
                Panes: [
                    { name: 'Summary' },
                    { name: 'Client Info' },
                    { name: 'Program' },
                    { name: 'People' },
                    { name: 'Case File' },
                    { name: 'New Document' },
                    { name: 'Youth Log' },
                    { name: 'Housing Assignments' },
                   
                ],
                ProfilePhotoFileID: this.ProfilePhotoURL()
            };
        },
        methods: {
            UpdateChartData() {
                this.$MasterAPI.ExecuteRequest("GET", "TAY/Clients/GetClientEnrollment", { Id: this.ChildRecordData.Id }, this.UpdateChartDataSuccess, () => { }, true);
            },
            UpdateChartDataSuccess(response) {
                this.$store.commit("Clients.ClientEnrollmentsList.ReplaceSingleRecord", response.data.data);
            },
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CloseRecord() {
                this.$parent.CloseRecord("Clients.ClientProfiles.Remove", "ChildList",this.ChildRecordData.Id);
            },
            ProfilePhotoURL() {
                this.$MasterAPI.ExecuteRequest("GET", "TAY/Clients/GetPhotoID", { membershipClientSubProgramID: this.ChildRecordData.Id }, this.ProfilePhotoURLSuccess, () => { }, false);
            },
            ProfilePhotoURLSuccess(response) {
                 if (response.data.data != null) {
                    this.ProfilePhotoFileID = this.$baseURL + '/API/Core/Files/GetFileContent/profilephoto?FileID=' + response.data.data;
                }
                else {
                    this.ProfilePhotoFileID = "/images/NoPhotoOnFile.jpg"
                }
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            Admin,
            Information,
            ChildSummary,
            People,
            HousingAssignmentsPane,
            Program,
            CaseFile,
            NewDocument,
            ClientServiceLog
        },
        mounted() { 
            if (this.CheckPermission("TAY.ClientAdmin")) {
                this.Panes.push({ name: 'Admin' });
            }
        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            },
            SubProgramFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChildRecordData.SubProgramID);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "ClientSubProgramMembership");
            }
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }
    @media only screen and (max-width: 576px) {
        h4{
        font-size: 1em;
        }
        h1{
        font-size: 1.5em;
        }
    }
    li a{
        color:black !important;
    }
    li.active a {
        color: black !important;
    }
</style>